import React from "react";
import { PropTypes } from "prop-types";

const WebsiteIcon = ({ size, color, children, ...props }) => (
  <svg {...props} viewBox="0 0 24 24" width={size} height={size} fill={color}>
    {children}
    <g
      id="Logos/Social/Fill/Website-24"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon id="Fill-1" points="0 0 24 0 24 24 0 24" />
      <g
        id="Group"
        transform="translate(1.000000, 2.000000)"
        fill={color}
        fillRule="nonzero"
      >
        <path
          d="M12.6691529,20.1490264 C13.7252353,18.283676 14.4759436,16.2613129 14.892792,14.1586766 L20.2098902,14.1586766 C18.8799242,17.3089179 16.038575,19.5660812 12.6691529,20.1490264 L12.6691529,20.1490264 Z"
          id="Path"
        />
        <path
          d="M9.9183763,19.2911127 C10.1239633,19.6733159 10.5228751,19.9117014 10.9568627,19.9117014 C11.3908504,19.9117014 11.7897622,19.6733159 11.9953492,19.2911127 C12.8623885,17.6789552 13.4929587,15.9504339 13.8676784,14.1586766 L8.04604706,14.1586766 C8.42076679,15.9504339 9.05133696,17.6789552 9.9183763,19.2911127 L9.9183763,19.2911127 Z"
          id="Path"
        />
        <path
          d="M9.24474527,20.1490264 C5.87532313,19.5660813 3.03397375,17.308918 1.70400767,14.1586766 L7.02110571,14.1586766 C7.43795423,16.2613129 8.18866277,18.2836761 9.24474527,20.1490264 L9.24474527,20.1490264 Z"
          id="Path"
        />
        <path
          d="M15.0655137,7.35016837 C15.3464951,9.27467237 15.3464951,11.229782 15.0655137,13.154286 L20.5722431,13.154286 C21.1434398,11.2617397 21.1434398,9.24271466 20.5722431,7.35016837 L15.0655137,7.35016837 Z"
          id="Path"
        />
        <path
          d="M14.0498902,13.154286 C14.3458297,11.2308971 14.3458297,9.27355726 14.0498902,7.35016837 L7.86383547,7.35016837 C7.56789599,9.27355726 7.56789599,11.2308971 7.86383547,13.154286 L14.0498902,13.154286 Z"
          id="Path"
        />
        <path
          d="M6.84821176,13.154286 C6.56723035,11.229782 6.56723035,9.27467237 6.84821176,7.35016837 L1.34148218,7.35016837 C0.770285507,9.24271466 0.770285507,11.2617397 1.34148218,13.154286 L6.84821176,13.154286 Z"
          id="Path"
        />
        <path
          d="M12.6691529,0.355462484 C13.7252335,2.22080751 14.4759419,4.24316471 14.892792,6.34579503 L20.2098902,6.34579503 C18.8799195,3.19556042 16.0385711,0.938404235 12.6691529,0.355462484 L12.6691529,0.355462484 Z"
          id="Path"
        />
        <path
          d="M9.9183763,1.21335895 C9.05133696,2.82551643 8.42076679,4.55403778 8.04604706,6.34579503 L13.8676784,6.34579503 C13.4929571,4.55404372 12.862387,2.82552828 11.9953492,1.21337621 C11.7897653,0.831171298 11.3908556,0.592778866 10.9568679,0.592778866 C10.5228802,0.592778866 10.1239665,0.831157459 9.9183763,1.21335895 L9.9183763,1.21335895 Z"
          id="Path"
        />
        <path
          d="M1.70400767,6.34579503 L7.02110571,6.34579503 C7.437956,4.24316468 8.18866449,2.22080747 9.24474527,0.355462484 C5.87532694,0.938404127 3.0339784,3.19556033 1.70400767,6.34579503 L1.70400767,6.34579503 Z"
          id="Path"
        />
      </g>
    </g>
  </svg>
);

WebsiteIcon.displayName = "WebsiteIcon";

WebsiteIcon.defaultProps = {
  color: "currentColor",
  children: null
};

WebsiteIcon.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string,
  children: PropTypes.node
};

export default WebsiteIcon;
